import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ReportTemplateCreation from "./routes/ReportTemplateCreation";
import { getRelativePath } from "Utils";
export default store => ({
  path: "progressreporttemplate(/:viewType)",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "progress-report" */ "./components"),
        import(
          /* webpackChunkName: "progress-report" */ "./modules/ProgressReportTemplateModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "progressReportTemplate",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  onEnter: (nextState, replace) => {
    const pathname = _.get(nextState, "location.pathname", "");
    const parts = _.split(pathname, "/");
    const templateIndex = _.indexOf(parts, "progressreporttemplate");
    if (
      templateIndex !== -1 &&
      !_.some(
        parts,
        part => _.includes(part, "card-view") || _.includes(part, "list-view")
      )
    ) {
      const newPath = _.join(
        _.concat(
          _.slice(parts, 0, templateIndex + 1),
          "list-view",
          _.slice(parts, templateIndex + 1)
        ),
        "/"
      );
      replace(getRelativePath(newPath));
    }
  },
  childRoutes: [ReportTemplateCreation(store)],
});
